<template>
  <div class="flex flex-1 gap-2">
    <template v-if="selectComponentTypes.includes(componentType)">
      <FormulateInput
        v-model="selectValue"
        :type="componentType"
        :label="label"
        :placeholder="placeholder"
        :element-class="(context, classes) => ['flex-1 min-w-full'].concat(classes)"
        :options="options"
        v-bind="dropdownsCommonProps"
        variant="alt"
        @input="($event) => handleArrayInput($event)"
      />
    </template>

    <template v-else-if="componentType === rangeComponentType">
      <FormulateInput
        v-for="_, i in rangeValue"
        v-model="rangeValue[i]"
        :key="`conditions-configuration-${i}`"
        :label="label"
        :placeholder="rangeConfig[i].placeholder"
        type="number"
        :min="0"
        :max="rangeMax"
        class="flex-1 flex flex-col"
        :element-class="(context, classes) => ['flex-1 min-w-full'].concat(classes)"
        :disabled="disabled"
        @keypress="sanitizeRangeInput"
        @blur="($event) => removeLeadingZeros($event, i)"
      >
        <template #label="{ label }">
          <span :class="['label', 'items-center', 'capitalize', 'max-w-full', rangeConfig[i].classes]">
            {{ label }}
          </span>
        </template>
      </FormulateInput>
    </template>

    <template v-else-if="componentType === emailComponentType">
      <FormulateInput
        v-model="emailValue"
        type="email"
        :label="label"
        :placeholder="placeholder"
        :element-class="(context, classes) => ['flex-1 min-w-full'].concat(classes)"
        :disabled="disabled"
        validation="required:trim|email"
        error-behavior="live"
        class="w-full"
      />
    </template>
  </div>
</template>

<script>
import { RANGE_MAX } from "./constants";
import helperMixin from "../mixins/helper";

export default {
  name: "ConfigurationComponent",

  mixins: [helperMixin],

  props: {
    componentType: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Object, Array],
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    selectValue: {
      get() {
        return this.value; 
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    rangeValue: {
      get() {
        return this.value.range;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    emailValue: {
      get() {
        return this.value.text;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, text: newValue });
      },
    },
    rangeConfig() {
      return [{
        placeholder: this.$t('components.workflow.min'),
        classes: "",
      }, {
        placeholder: this.$t('components.workflow.max'),
        classes: "invisible",
      }];
    },
    rangeMax() {
      return RANGE_MAX;
    },
  },

  methods: {
    async handleArrayInput(event) {
      this.$emit("handleInput", event);
    },

    sanitizeRangeInput(event) {
      if (event.keyCode < 48 || event.keyCode > 57) {
        event.preventDefault();
      }

      if (Number(event.target.value) >= RANGE_MAX) {
        event.preventDefault();
      }
    },

    removeLeadingZeros(event, index) {
      const range = [...this.rangeValue];
      const { value } = event.target;
      range[index] = value.length > 1 ? value.replace(/^0+/, "") : value;

      if (range[index] > RANGE_MAX) {
        range[index] = RANGE_MAX;
      }

      this.$emit("input", { ...this.value, range });
    },
  },
};
</script>
